/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'card-files': {
    width: 16,
    height: 16,
    viewBox: '0 0 88 96',
    data: '<g fill-rule="evenodd"><path pid="0" fill-rule="nonzero" d="M86.3 21.3L66.5 1.5c-.6-.6-1.3-.9-2.1-.9L24.2.5c-1.9 0-3.7.7-5 2.1-1.3 1.3-2.1 3.1-2.1 5v9.2H8c-1.9 0-3.7.7-5 2.1-1.3 1.3-2.1 3.1-2.1 5v64.6c0 3.9 3.2 7.1 7.1 7.1h55.9c3.9 0 7.1-3.2 7.1-7.1v-9.1h9.1c3.9 0 7.1-3.2 7.1-7.1V23.5c0-.8-.4-1.6-.9-2.2zM67.4 11l9.4 9.4h-9.4V11zm-2.5 77.4c0 .5-.5 1-1 1h-56c-.5 0-1-.5-1-1V23.8c0-.4.2-.6.3-.7.1-.1.3-.3.7-.3H17v49.4c0 3.9 3.2 7.1 7.1 7.1h40.7v9.1h.1zm15.2-15.2h-56c-.6 0-1-.5-1-1V7.6c0-.4.2-.6.3-.7.1-.1.4-.3.7-.3l37.1.1v16.8c0 1.7 1.4 3 3 3h16.7v45.7c.2.5-.3 1-.8 1z"/><path pid="1" d="M63.7 51c-.7-1-2.2-1.1-3.1-.3L58.2 53c-.9.8-2.3.7-3-.2l-7.5-10.1c-.9-1.1-2.6-1.1-3.3.1L31.5 63.3c-.8 1.3.1 3.1 1.7 3.1h37.5c1.6 0 2.6-1.9 1.7-3.2L63.7 51z"/><circle pid="2" cx="65.6" cy="39.4" r="5.2"/></g>'
  }
})
